<template>
    <div>
        <v-layout row justify-start>
            <v-switch
                color="success"
                class="pl-3 mt-2 pt-1"
                @change="showCompletedChanged"
                v-model="showCompleted"
                label="Show Completed"
                hide-details
                style="max-width: 185px;"
            ></v-switch>
            <v-btn
                small
                color="success"
                class="ml-2 mb-0"
                @click="openMarkCompletedDialog"
                v-if="filesToDisplay.some((f) => f.selected)"
                >Mark as Completed</v-btn
            >
        </v-layout>
        <v-layout
            row
            wrap
            class="ma-2"
            v-if="!loading"
            style="align-items: stretch;"
        >
            <div
                class="shared-file"
                style="height: 100%; position: relative;"
                v-for="file in filesToDisplay"
            >
                <v-layout row justify-center>
                    <v-checkbox
                        class="my-0 py-0"
                        hide-details
                        color="success"
                        v-if="!file.isCompleted"
                        v-model="file.selected"
                    ></v-checkbox>
                    <div v-if="file.isCompleted" class="mb-3"></div>
                    <v-chip
                        v-if="file.isCompleted"
                        color="success"
                        text-color="white"
                        small
                        class="mb-2 completed-badge"
                    >
                        <v-icon color="white" left small>mdi-check</v-icon>
                        Completed
                    </v-chip>
                </v-layout>
                <v-layout
                    row
                    justify-center
                    class=""
                    v-bind:class="{ 'pt-4': file.isCompleted }"
                >
                    <v-icon
                        class="mr-3 ml-1 mt-0"
                        dark
                        large
                        :color="getFileIconColor(file)"
                        >{{ getFileIcon(file) }}</v-icon
                    >
                </v-layout>
                <div
                    :title="file.fileName"
                    class="body-1 font-weight-bold text-xs-center mt-2 file-name"
                >
                    {{ truncateText(file.fileName, 20) }}
                </div>
                <div
                    class="caption font-weight-regular mt-2 pb-1"
                    style="color: #666;"
                >
                    <span class="font-weight-medium">Shared By:</span>
                    {{ file.uploadedBy }}
                </div>
                <div
                    class="caption font-weight-regular mt-2 pb-1"
                    style="color: #666;"
                >
                    <span class="font-weight-medium">Expiration:</span>
                    {{ file.expirationDate | date }}
                </div>
                <div
                    v-if="file.instruction"
                    class="caption font-weight-regular mt-2"
                    style="color: #666;"
                >
                    <span class="font-weight-medium">Instruction:</span>
                    <div :title="file.instruction">
                        {{ truncateText(file.instruction, 50) }}
                    </div>
                </div>
                <div
                    v-if="!file.editing"
                    class="caption font-weight-regular mt-0"
                    style="color: #666;"
                >
                    <span class="font-weight-medium">Note:</span>
                    {{ truncateText(file.note, 60) }}
                    <v-btn
                        @click="edit(file)"
                        flat
                        icon
                        color="success"
                        class="ma-0"
                    >
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                </div>
                <div
                    v-if="file.editing"
                    style="border: 1px solid #5cb860;"
                    class="pa-2 mt-2"
                >
                    <v-text-field
                        v-model="file.copy.note"
                        hide-details
                        label="Note"
                        class="mx-0 mt-1 pa-0"
                        outline
                    ></v-text-field>
                    <v-checkbox
                        v-model="file.copy.isCompleted"
                        label="Completed"
                        class="mt-2"
                        color="success"
                        hide-details
                    ></v-checkbox>
                    <v-layout class="my-1" row justify-center>
                        <v-btn
                            small
                            :dark="!processing"
                            color="default"
                            @click="rollback(file)"
                            class="mr-1 mb-0"
                            :disabled="processing"
                            >cancel</v-btn
                        >
                        <v-btn
                            small
                            color="success"
                            @click="save(file)"
                            class="mb-0"
                            :loading="processing"
                            >Save</v-btn
                        >
                    </v-layout>
                </div>
                <v-layout column justify-center style="margin-top: auto;">
                    <!-- <v-btn
                        class="text-xs-center mb-2 shared-file-download-button"
                        outlined
                        color="success"
                        @click="downloadFile(file)"
                    >
                        <v-icon left>mdi-cloud-download</v-icon
                        ><span style="padding-top: 3px;">Download</span>
                    </v-btn>
                    <v-btn
                        class="text-xs-center mb-2 shared-file-download-button"
                        outlined
                        color="success"
                        @click="viewFile(file)"
                    >
                        <v-icon left>mdi-file-search</v-icon
                        ><span style="padding-top: 3px;">View</span>
                    </v-btn> -->
                    <v-btn
                        class="text-xs-center mb-0 shared-file-download-button"
                        outlined
                        color="success"
                        small
                        @click="downloadFile(file)"
                        :disabled="isMessage(file)"
                    >
                        <v-icon left>mdi-cloud-download</v-icon>
                        <span style="padding-top: 3px;">Download</span>
                    </v-btn>
                    <v-btn
                        class="text-xs-center mb-1 shared-file-download-button"
                        outlined
                        color="success"
                        small
                        :disabled="isMessage(file)"
                        @click="viewFile(file)"
                    >
                        <v-icon left>mdi-file-find</v-icon>
                        <span style="padding-top: 3px;">View</span>
                    </v-btn>
                </v-layout>
            </div>
            <div v-if="!files.length">
                <v-card width="100%" class="pa-3">
                    <div class="headline text-xs-center">No Files</div>
                </v-card>
            </div>
            <div v-if="files.length && !filesToDisplay.length">
                <v-card width="100%" class="pa-3">
                    <div class="headline text-xs-center">No Open Files</div>
                </v-card>
            </div>
        </v-layout>
        <v-dialog persistent v-model="markCompletedDialog" max-width="400">
            <v-card class="pa-3">
                <v-card-title class="headline pl-0 pt-0 pb-2"
                    >Mark as Completed</v-card-title
                >
                <div class="font-weight-medium">
                    The
                    {{ filesToDisplay.filter((f) => f.selected).length }}
                    selected files will be marked as completed
                </div>

                <v-card-actions class="mr-0 mt-3 pb-0">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="default"
                        dark
                        @click="markCompletedDialog = false"
                        >Cancel</v-btn
                    >
                    <v-btn
                        :loading="processing"
                        color="success"
                        @click="markAsCompleted()"
                    >
                        Confirm
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from "moment";
import { truncate, pluralize, onlyUnique } from "../../utils/helpers.js";

export default {
    data: () => ({
        files: [],
        filesToDisplay: [],
        sharedByList: [],
        sharedBy: "",
        loading: true,
        processing: false,
        showCompleted: false,
        markCompletedDialog: false,

        rules: {
            required: (value) => !!value || "Required.",
        },
    }),
    async created() {
        this.loadFiles();
    },
    watch: {},
    beforeDestroy() {},
    methods: {
        async loadFiles() {
            try {
                const files = await this.$http.get(
                    "api/sharedFiles/getFilesSharedWithUser?user=" +
                        this.$store.state.authentication.user,
                );

                this.files = files.map((file) => {
                    file.editing = false;
                    file.selected = false;

                    return file;
                });

                this.filesToDisplay = this.showCompleted
                    ? this.files
                    : this.files.filter((s) => !s.isCompleted);
                // this.sharedByList = this.files
                //     .map((f) => f.uploadedBy)
                //     .filter(onlyUnique);

                this.loading = false;
            } catch (e) {
                this.loading = false;
            }
        },
        sharedByChanged(value) {
            if (!value) {
                this.filesToDisplay = this.files;

                return;
            }

            this.filesToDisplay = this.files.filter((f) =>
                f.uploadedBy.includes(value),
            );
        },
        showCompletedChanged(value) {
            if (!value) {
                this.filesToDisplay = this.files.filter((s) => !s.isCompleted);

                return;
            }

            this.filesToDisplay = this.files;
        },
        openMarkCompletedDialog() {
            this.markCompletedDialog = true;
        },
        getFileIcon(file) {
            if (!file.url && !file.fileName) return "mdi-message-processing";

            switch (this.getFileType(file.url)) {
                case "pdf":
                    return "mdi-file-pdf";
                case "docx":
                    return "mdi-file-word";
                case "xls":
                case "xlsx":
                    return "mdi-file-excel";
                case "mp3":
                case "wav":
                case "wma":
                    return "mdi-play-box-outline";
                case "jpg":
                case "png":
                case "gif":
                    return "mdi-image-area";
                case "zip":
                    return "mdi-zip-box";
                default:
                    return "mdi-file";
            }
        },
        getFileIconColor(file) {
            if (!file.url && !file.fileName) return "#295293";

            switch (this.getFileType(file.url)) {
                case "pdf":
                    return "#ad0b00";
                case "docx":
                    return "#295293";
                case "xls":
                case "xlsx":
                    return "#107a44";
                case "mp3":
                case "wav":
                case "wma":
                    return "purple";
                case "jpg":
                case "png":
                case "gif":
                    return "#ff755a";
                case "zip":
                    return "#f7cc4c";
                default:
                    return "blue";
            }
        },
        getFileType(url) {
            const parsedUrl = new URL(url);
            const path = parsedUrl.pathname;
            const match = path.match(/\.([^.?#]+)(?:[?#]|$)/);

            // If no match, return null
            if (!match) return null;

            const extension = match[1].toLowerCase();
            return extension.length > 5 ? null : extension.toLowerCase();
        },
        truncateText(fileName, count = 30) {
            return truncate(fileName, count);
        },
        isMessage(file) {
            return !file.url && !file.fileName;
        },
        viewFile(file) {
            window.open(file.url);
        },
        async downloadFile(file) {
            // if (this.$store.state.authentication.user == "1791@utaw.org") {
            //     return this.downloadWithXMLHttpRequest(file);
            // }

            try {
                const response = await fetch(file.url);
                if (!response.ok)
                    throw new Error("Network response was not ok");

                const blob = await response.blob();
                const link = document.createElement("a");
                const blobUrl = window.URL.createObjectURL(blob);

                link.href = blobUrl;
                link.download = file.fileName; // Default filename if none provided
                document.body.appendChild(link);
                link.click();

                // Clean up
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);
            } catch (error) {
                console.error("Download failed:", error);

                this.$notify({
                    text: "Error downloading: " + file.fileName,
                    group: "notification",
                    type: "error",
                });
            }
        },
        downloadWithXMLHttpRequest(file) {
            const xhr = new XMLHttpRequest();
            xhr.responseType = "blob";
            xhr.onload = function() {
                if (xhr.status === 200) {
                    const link = document.createElement("a");
                    link.href = window.URL.createObjectURL(xhr.response);
                    link.download = file.fileName;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(link.href);
                }
            };
            xhr.onerror = function() {
                console.error("XHR Download failed");
                this.$notify({
                    text: "Error downloading: " + file.fileName,
                    group: "notification",
                    type: "error",
                });
            };
            xhr.open("GET", file.url);
            xhr.send();
        },
        edit(file) {
            file.copy = JSON.parse(JSON.stringify(file));
            file.editing = true;
        },
        rollback(file) {
            file.editing = false;
            file.note = file.note;
            file.isCompleted = file.isCompleted;
        },
        async save(file) {
            try {
                this.processing = true;

                await this.$http.post(
                    "api/sharedFiles/update?id=" +
                        file.id +
                        "&note=" +
                        (file.copy.note ? file.copy.note : "") +
                        "&isCompleted=" +
                        file.copy.isCompleted,
                );

                file.editing = false;
                file.note = file.copy.note;
                file.isCompleted = file.copy.isCompleted;

                this.processing = false;

                this.loadFiles();
            } catch (e) {
                this.processing = false;
            }
        },
        async markAsCompleted() {
            try {
                this.processing = true;

                const ids = this.filesToDisplay
                    .filter((f) => f.selected)
                    .map((m) => m.id);

                await this.$http.post("api/sharedFiles/markAsCompleted", ids);

                this.processing = false;
                this.markCompletedDialog = false;

                this.loadFiles();

                this.$notify({
                    group: "notification",
                    text: ids.length + " Files Updated",
                    type: "success",
                });
            } catch (e) {
                this.processing = false;
            }
        },
    },
};
</script>
<style>
.shared-file {
    width: 220px;
    background-color: #fff;
    margin: 8px;
    padding: 12px;
    border-radius: 10px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    min-height: 300px;
    transition: transform 0.2s;
    position: relative; /* Added to serve as reference for absolute positioning */
}
.shared-file:hover {
    transform: translateY(-5px);
}
.shared-file .caption {
    word-break: break-word;
    white-space: normal;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.file-name {
    word-break: break-word;
    white-space: normal;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    color: #333;
}
.shared-file > * {
    flex: 1 0 auto;
}
/*.shared-file-download-button {
    min-width: 150px;
    height: 40px;
    padding: 0 10px;
    border-radius: 20px;
    background-color: #fff;
    transition: background-color 0.3s;
}
.shared-file-download-button:hover {
    background-color: #e0f7e0;
}*/
.shared-file-download-button {
    padding: 0 0px;
    border-radius: 20px;
    background-color: #fff;
    transition: background-color 0.3s;
}

.shared-file-download-button:hover {
    background-color: #e0f7e0;
}
.completed-badge {
    position: absolute;
    top: 10px;
    bottom: 10px;
    right: 10px; /* Changed from left to right for top-right placement */
    z-index: 1;
}
</style>
